import styled from "styled-components";
import { transparentize } from "polished";
import { Icon } from "_/components/icon";

// Dropdown menu border radius.
const BORDER_RADIUS = "4px";

export const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;

  min-width: 160px;

  background-color: ${(p) => p.theme.background.tertiary};
  color: ${(p) => p.theme.text.default};

  border-radius: ${BORDER_RADIUS};

  box-shadow:
    0 0 4px ${(p) => transparentize(0.8, p.theme.overlayMenu.border)},
    0 2px 12px ${(p) => transparentize(0.8, p.theme.border.default)};

  /* No placement-based transforms; Floating UI handles offset + positioning */
  box-sizing: border-box;
`;

export const MenuItem = styled.div<{ $disabled: boolean }>`
  padding: 8px 12px;
  white-space: nowrap;
  font-size: 14px;

  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  color: ${(p) => (p.$disabled ? p.theme.text.disabled : p.theme.text.default)};

  &:hover {
    background-color: ${(p) =>
      p.$disabled ? "initial" : p.theme.background.quaternary};
  }

  &:first-of-type {
    border-radius: ${BORDER_RADIUS} ${BORDER_RADIUS} 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 ${BORDER_RADIUS} ${BORDER_RADIUS};
  }
`;

export const TextItem = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${Icon} {
    font-size: 16px;
  }
`;

export const Separator = styled.hr`
  /* Reset default margins to avoid accidental overflow/scrollbars */
  margin: 6px 10px;
  width: calc(100% - 20px);
  border: none;
  height: 1px;
  background: ${(p) => p.theme.background.secondary};
`;
